import { Card, Stack, Text, Title } from "@mantine/core";
import { memo } from "react";
import { RoundedNumberFormat } from "../../../../utils/RoundedNumberFormat";
import type { ToolResultMetric } from "../ToolResultRenderer.types";

interface MetricCardProps {
  data: ToolResultMetric;
}

function MetricCardComponent({ data }: MetricCardProps) {
  return (
    <Card padding="md" withBorder>
      <Stack gap="xs">
        <Title order={4}>{data.label}</Title>
        <Text fw={700} size="xl">
          {typeof data.value === "number" ? (
            <RoundedNumberFormat
              displayType="text"
              suffix={data.unit !== undefined ? ` ${data.unit}` : undefined}
              value={data.value}
            />
          ) : (
            <>
              {data.value}
              {data.unit !== undefined ? ` ${data.unit}` : null}
            </>
          )}
        </Text>
        {data.sublabel !== undefined ? (
          <Text c="dimmed" size="xs">
            {data.sublabel}
          </Text>
        ) : null}
      </Stack>
    </Card>
  );
}

const MetricCard = memo(MetricCardComponent);

export { MetricCard };
